import { STRAD_URL } from "./brand";
import { el } from "./dom";

// A factual description of the firm and where Trust Lens comes from. NOT a
// marketing or solicitation section: it states what STRAD does, that Trust Lens
// holds professional judgement, and that it is neither advice nor a regulated
// service.
export const ABOUT_FIRM =
  "STRAD Ltd is an alternatives investment advisory firm. It acts as a " +
  "fractional chief investment officer to institutional investors and family " +
  "offices, providing manager selection, co-investment and secondaries support, " +
  "transaction support, and independent due diligence and evaluation across " +
  "private markets.";

export const ABOUT_ORIGIN =
  "Trust Lens comes out of that work. Independent evaluation in private markets " +
  "turns on judgement about people: which managers to back, which counterparties " +
  "deliver, whose read to trust. Trust Lens is the private instrument STRAD " +
  "built to hold that judgement, now offered as a standalone tool. It is not " +
  "investment advice and not a regulated service.";

export const ABOUT_REGISTRATION =
  "STRAD Ltd is registered in England and Wales, company number 16363175, " +
  "71-75 Shelton Street, London WC2H 9JQ. More at ";

export function renderAbout(): HTMLElement {
  return el(
    "div",
    { class: "about" },
    el("span", { class: "label", text: "About STRAD" }),
    el("p", { class: "lede data-note", text: ABOUT_FIRM }),
    el("p", { class: "lede data-note", text: ABOUT_ORIGIN }),
    el(
      "p",
      { class: "lede data-note" },
      ABOUT_REGISTRATION,
      el("a", {
        class: "link-inline",
        href: STRAD_URL,
        text: "strad.global",
        attrs: { target: "_blank", rel: "noopener noreferrer" },
      }),
      ".",
    ),
  );
}

export function openAboutPanel(): void {
  const root = el("div", { class: "consent" });
  const close = () => root.remove();
  root.append(
    el(
      "div",
      { class: "consent__card", attrs: { role: "dialog", "aria-modal": "true" } },
      renderAbout(),
      el("div", { class: "consent__actions" }, el("button", { class: "btn btn--ghost", text: "Close", on: { click: close } })),
    ),
  );
  document.body.append(root);
}
